import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { isEmpty } from 'lodash'
import {
    COOKIE_TOKEN,
    STORAGE_USER_PROFILE,
    URL_API_PREFIX,
    URL_FILE_PREFIX
} from 'config/const/global'
import {
    METHOD_DELETE,
    METHOD_GET,
    METHOD_POST,
    METHOD_PUT,
} from 'config/const/api'
import {
    TYPE_ACCOUNT,
    TYPE_PASSWORD,
} from 'config/const/type'
import { delCookie, getCookie } from 'utils/cookies'


// APIs relating to user
const waV1FileApi = createApi({
    reducerPath: "waV1_file",
    baseQuery: fetchBaseQuery({
        baseUrl: URL_FILE_PREFIX,
        prepareHeaders: (headers, { getState }) => {
            const lToken = getCookie(COOKIE_TOKEN)
            if (!isEmpty(lToken) && lToken === getState().global.token) headers.set('authorization', `Bearer ${lToken}`)

            return headers
        },
        responseHandler: (response) => {
            if (!response.ok) {
                throw new Error(response.statusText);
            }

            return response.blob()
        }
    }),
    endpoints: builder => ({

        getFile: builder.mutation({
            query(params) {
                return {
                    url: `${params}`,
                    method: METHOD_GET
                }
            },
            transformResponse(res, meta, arg) {
                let file = window.URL.createObjectURL(res);

                return file
            }
        }),




    })
})

export const {
    useGetFileMutation,
} = waV1FileApi
export default waV1FileApi